<template>
  <v-card color="grey lighten-3" elevation="0">
    <div class="accent-wrapper px-4 py-3">
      <div class="d-flex align-center pointer" @click="toggle">
        <v-btn icon :color="inUse ? 'secondary' : ''" @click.stop="toggle">
          <v-icon>{{ inUse ? "$checked" : "$unchecked" }}</v-icon>
        </v-btn>
        <div class="text-h6 flex-fill">{{ label }}</div>
      </div>
      <v-expand-transition>
        <div v-if="inUse && rule">
          <vue-query-builder
            v-model="rule.value"
            :rules="queryRules"
          >
            <template v-slot:default="slotProps">
              <query-builder-group
                v-bind="slotProps"
                :query.sync="rule.value"
                :locked="locked"
              />
            </template>
          </vue-query-builder>
        </div>
      </v-expand-transition>
    </div>
  </v-card>
</template>

<style scoped>
.accent-wrapper {
  border-left: 0.4rem solid rgba(0, 0, 0, 0.1);
}
</style>

<script>
import VueQueryBuilder from "vue-query-builder";
import QueryBuilderGroup from "./QuestionRules.Group.vue";
import equal from "deep-is";

export default {
  components: { VueQueryBuilder, QueryBuilderGroup },
  data: () => ({
    inUse: false,
    innerValue: []
  }),
  props: {
    label: {
      type: String
    },
    ruleKey: {
      type: String,
      required: true
    },
    value: {
      type: Array
    },
    queryRules: {
      type: Array,
      required: true
    },
    locked: {
      type: Boolean
    }
  },
  computed: {
    rule() {
      return this.innerValue.find(x => x.key === this.ruleKey);
    }
  },
  watch: {
    inUse(value) {
      if (value) {
        if (!this.rule) {
          this.innerValue.push({
            key: this.ruleKey,
            value: {
              logicalOperator: "all",
              children: []
            }
          });
        }
      } else if (this.rule) {
        let index = this.innerValue.findIndex(x => x.key === this.ruleKey);
        this.innerValue.splice(index, 1);
      }
    },
    innerValue(value) {
      if (!equal(value, this.value)) this.$emit("input", value);
    },
    value(val) {
      if (!equal(val, this.innerValue)) {
        this.innerValue = val;

        if (this.rule) this.inUse = true;
      }
    }
  },
  methods: {
    toggle() {
      if (!this.locked) this.inUse = !this.inUse;
    }
  },
  mounted() {
    if (this.value) {
      this.innerValue = this.value;
      if (this.rule) this.inUse = true;
    }
  }
};
</script>


